import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEdit, FaTrash, FaWallet, FaClipboardList } from "react-icons/fa";
import { FaUserShield } from "react-icons/fa";
import {
  getUserList,
  deleteUser,
  updateUserStatus
} from "../../redux/services/User Services/User.Services";
import { STATUS_OPTIONS, STATUS_BADGE } from '../../Constant/leadConstent';
import { getUserRole } from "../../Utils/role";
import { openModal } from "../../redux/features/modalSlice";
import Pagination from "../../common/Pagination";
import { openProductModal } from "../../redux/features/productModalSlice";
import { startAiCall } from "../../redux/services/Ai Services/Ai.Services";
import { ActiveModuleList } from "../../redux/services/moduleService/module.Services";
import { KycChangeStatusList } from "../../redux/services/kycService/kyc.Services";
import { successToast, errorToast } from "../../Utils/toast";
import Search from "../../common/Search";
import { useDispatch } from "react-redux";
function ClintList() {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [showPasswords, setShowPasswords] = useState({});
  const [initialLoading, setInitialLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [totalLeads, setTotalLeads] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedVendorIds, setSelectedVendorIds] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const role = localStorage.getItem("role");
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const isAdmin = role === "admin";

  const fetchUserList = async (pageNo = 1) => {
    try {

      setTableLoading(true);

      const payload = {

        search,
        page: pageNo,
        category_id: categoryId || undefined,
        sort_by: sortBy || undefined,
        sort_order: sortOrder || undefined,
        per_page: limit,

      };
      const res = await getUserList(payload);
      setStaff(res?.data || []);
      setPage(res?.current_page || 1);
      setTotalPages(res?.last_page || 1);
      setTotalLeads(res?.total || 0);
    } catch (error) {
      console.log(error);
      errorToast("Failed to load staff");
    } finally {
      setInitialLoading(false);
      setTableLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchUserList();
  // }, []);
  useEffect(() => {
    fetchUserList(1, false);
  }, [limit, search, categoryId, sortOrder, sortBy]);

  const togglePassword = (id) => {
    setShowPasswords((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortBy(field);
      setSortOrder("asc");
    }
  };
  const getVendorId = (lead) => {
    return (
      lead?.vendor_id ||
      lead?.vendor?.id ||
      lead?.vendor?.vendor_id ||
      null
    );
  };
  const handleAiCalling = async (vendor) => {
    try {
      const leads = vendor?.leads || [];

      if (!leads.length) {
        return errorToast("This vendor has no leads");
      }

      setLoading(true);

      const payload = {
        vendor_id: String(vendor.id),

        leads: leads.map((lead) => ({
          lead_id: lead?.lead_id || lead?.id,
          phone: lead?.phone || lead?.mobile,
        })),
      };

      console.log("AI Call Payload:", payload);

      const response = await startAiCall(payload);

      if (response?.success !== false) {
        successToast(
          response?.message || "AI calling started successfully"
        );
      } else {
        errorToast(
          response?.message || "AI calling failed"
        );
      }

    } catch (error) {
      console.error("AI Calling Error:", error);

      errorToast(
        error?.response?.data?.message ||
        error?.message ||
        "AI calling failed"
      );
    } finally {
      setLoading(false);
    }
  };

  // const handleWhatsappMessage = async () => {
  //     const selectedLeads = selectedVendorIds();
  //     if (!selectedLeads.length) {
  //         return errorToast("Please select at least one lead");
  //     }
  //     const payload = selectedLeads.map((lead) => ({
  //         lead_id: lead.id,
  //         vendor_id: getVendorId(lead),
  //         phone: lead.mobile,
  //     }));
  //     console.log("WhatsApp Payload:", payload);
  // };
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedVendorIds(staff.map((vendor) => vendor.id));
      setSelectAll(true);
    } else {
      setSelectedVendorIds([]);
      setSelectAll(false);
    }
  };

  const toggleVendorSelection = (id) => {
    setSelectedVendorIds((prev) => {
      const updated = prev.includes(id)
        ? prev.filter((vendorId) => vendorId !== id)
        : [...prev, id];

      setSelectAll(
        staff.length > 0 && updated.length === staff.length
      );

      return updated;
    });
  };

  const handleDelete = async (id) => {
    try {
      const res = await deleteUser({ id });
      if (res?.success) {
        successToast(res?.message);
        fetchUserList(page);
      } else {
        errorToast(res?.message);
      }
    } catch (error) {
      errorToast(error?.message || "Delete failed");
    }
  };

  const handlePageChange = (newPage) => {
    if (
      newPage >= 1 &&
      newPage <= totalPages &&
      !tableLoading
    ) {
      setPage(newPage);
      fetchUserList(newPage, false);
    }
  };

  // if (initialLoading) {
  //   return (
  //     <div className="text-center py-5">
  //       <div className="spinner-border text-primary"></div>
  //     </div>
  //   );
  // }

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between  page-header-breadcrumb">
        <div className="title_member">
          <h4>Vendor  List</h4>
        </div>


        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <button
            className="add-btn"
            onClick={() =>
              // dispatch(
              //   openProductModal({
              //     type: "create-user",
              //     title: "Add User",
              //     data: {
              //       refreshData: fetchUserList,
              //     },
              //   }),
              // )
              navigate("/add-user")
            }
          >
            + Add Vendor
          </button>
            <button
    className="add-btn"
    onClick={() => navigate("/deleted-vendor-list")}
  >
    Deleted Vendors
  </button>

          {/* {selectedVendorIds.length > 0 && (
    <select
        className="form-select"
        style={{ width: "200px" }}
        defaultValue=""
        disabled={loading}
        onChange={async (e) => {
            const action = e.target.value;

            if (!action) return;

            const selectedVendors = staff.filter((vendor) =>
                selectedVendorIds.includes(vendor.id)
            );

            if (action === "ai_calling") {

                for (const vendor of selectedVendors) {
                    await handleAiCalling(vendor);
                }

            }

            e.target.value = "";
        }}
    >
        <option value="">
            {loading ? "Processing..." : "Select Action"}
        </option>

        <option value="ai_calling">
            AI Calling
        </option>

        <option value="whatsapp_message">
            WhatsApp Message
        </option>
    </select>
)} */}
        </div>



        {/* <div>
            {selectedLeadIds.length > 0 && (
              <button
                className="btn btn-warning btn-sm me-2"
                onClick={openModal}
              >
                <FaExchangeAlt /> Reassign ({selectedLeadIds.length})
              </button>
            )}

            <button
              className="btn btn-secondary btn-sm"
              onClick={() => navigate("/lead-staff-list")}
            >
              <FaArrowLeft /> Back
            </button>
          </div> */}



      </div>
      <div className="main_page">
        {(totalLeads > 0 || search) && (
          <div className="d-flex justify-content-end align-items-center mx-2 mb-2">
            <Search
              search={search}
              placeholder="Search By Mobile..."
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
          </div>
        )}
        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  {/* <th>
                <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
              </th> */}
                  <th>Sr.No</th>
                  <th >Vendor Name </th>
                  <th>Email{" "}</th>
                  <th>Mobile{" "}</th>
                  {/* <th>Category</th> */}
                  {/* <th> Sub Category</th> */}
                  {/* <th>Plan</th> */}
                  {/* <th>Status</th> */}
                  <th>Change Status</th>
                  <th>KYC Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {tableLoading ? (
                  <tr>
                    <td colSpan="8" className="text-center">
                      <div className="spinner-border text-primary"></div>
                    </td>
                  </tr>
                ) : (
                  staff.map((item, index) => (
                    <tr key={item.id}>
                      {/* <td>
                    <input
                      type="checkbox"
                      checked={selectedVendorIds.includes(item.id)}
                     onChange={() => toggleVendorSelection(item.id)}
                    />
                  </td> */}
                      <td> {(page - 1) * limit + index + 1}</td>
                      <td>{item?.name}</td>
                      <td>{item?.email}</td>
                      <td>{item?.mobile || "-"}</td>
                      {/* <td>{item?.user_category?.category?.name || "-"}</td> */}
                      {/* <td>{item?.user_category?.subcategory?.name || "-"}</td> */}
                      {/* <td>{item?.user_category?.plan?.name || "-"}</td> */}

                      <td>
                        <div className="city-status-switch">
                          <input
                            type="checkbox"
                            id={`status-${item.id}`}
                            className="city-status-input"
                            checked={item.status === 1}
                            onChange={() =>
                              dispatch(
                                openProductModal({
                                  type: "change-toggle-status",
                                  title: "Change Status",
                                  data: {
                                    id: item.id,
                                    // currentStatus: item.status === 1 ? "Active" : "Inactive",
                                     status: item.status === 1 ? "Active" : "Inactive",
                                    statusFunction: updateUserStatus,
                                    onSuccess: () => fetchUserList(page),
                                  }
                                })
                              )
                            }
                          />

                          <label
                            htmlFor={`status-${item.id}`}
                            className="city-status-label"
                          >
                            <span className="city-status-ball"></span>

                            <span className="city-status-text">
                              {item.status === 1 ? "Active" : "Inactive"}
                            </span>
                          </label>
                        </div>
                      </td>
                      {/* {status === "success" && ( */}

                      <td>
                        <select
                          className={`form-select form-select-sm kyc-status-select ${item.kyc_status === "approved"
                            ? "kyc-approve"
                            : item.kyc_status === "rejected"
                              ? "kyc-reject"
                              : "kyc-pending"
                            }`}
                          value={item.kyc_status || "pending"}
                          onChange={(e) => {
                            const newStatus = e.target.value;
                            if (newStatus === (item.kyc_status || "pending")) return;
                            dispatch(
                              openModal({
                                type: "kyc-add-remark",
                                title: "Add Remark",
                                data: {
                                  id: item.id,
                                  statusOptions: STATUS_OPTIONS,
                                  currentStatus: item.kyc_status || "pending",
                                  newStatus: newStatus,

                                  refreshRemarks: () => fetchUserList(page),

                                  onSubmit: async (payload) => {
                                    const res = await KycChangeStatusList(payload);
                                    return res;
                                  },
                                },
                              })
                            );
                          }}
                          style={{ width: "140px", height: "36px", fontSize: "13px", fontWeight: 600 }}
                        >
                          <option value="pending">Pending</option>
                          <option value="approved">Approve</option>
                          <option value="rejected">Reject</option>
                        </select>



                      </td>
                      {/* )} */}

                      <td >
                        <div className="d-flex align-items-center justify-content-center gap-1">
                          <button
                            className="st-action-btn st-view-btn"
                            onClick={() =>
                              navigate(`/view-user/${item.id}`)
                            }
                          >
                            <FaEye />
                          </button>



                          {/* {(item.kyc_status === "pending" || !item.kyc_status) && ( */}
                          <button
                            type="button"
                            className="btn btn-sm btn-primary"

                            onClick={() => navigate(`/upload-kyc/${item.user_id}`)}
                          >
                            KYC
                          </button>
                          {/* )} */}


                          {/* <button
                            className="st-action-btn st-edit-btn"
                            onClick={() => navigate(`/permissions/${item.id}`)}
                            title="Manage Permissions"
                          >
                            <FaUserShield />
                          </button> */}
                          <button
                            className="st-action-btn st-edit-btn"
                            onClick={() =>
                              navigate(`/update-user/${item.id}`)
                            }
                          >
                            <FaEdit />
                          </button>
                          <button
                            className="st-action-btn st-edit-btn"
                            // onClick={() =>
                            //   dispatch(
                            //     openModal({
                            //       type: "add-manual-plan",
                            //       title: "Add Plan",
                            //       data: {
                            //         ...item,
                            //         user_id: item.user_id,
                            //         name: item.name,
                            //         mobile: item.mobile,
                            //         refreshData: fetchUserList,
                            //       },
                            //     })
                            //   )
                            // }
                             title="Assign Plan"
                            onClick={() =>
                              navigate("/asign-plan-user", {
                                state: { subscription: item },
                              })
                            }
                          >


                            <FaUserShield />
                          </button>
                          <button
                            className="st-action-btn st-view-btn"
                            title="Recharge History"
                            onClick={() =>
                              navigate(`/plan-transaction-history/${item.user_id}`)
                            }
                          >
                            <FaWallet />
                          </button>
                          <button
                            className="st-action-btn st-delete-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "delete-user",
                                  title: "Delete User",
                                  data: {
                                    id: item.id,
                                    deleteFunction: deleteUser,
                                    refreshData: fetchUserList,
                                  },
                                })
                              )
                            }
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClintList;